import React, { useEffect } from "react"
import { GroupsWidget } from "./ha/groups-widgets"
import { CreateCluster } from "./ha/AddCluster"
import { useState } from "react"
import { getclusters, getclustersglobal } from "./request/request"
import { useAppSelector } from "../../../../redux/hooks"
import { EdistCluster } from "./ha/EdistCluster"
import { useAuth } from "../../auth"
type ID = undefined | null | number


export default function Highavailavility(props: any) {
  const { currentUser } = useAuth()
  const [ID, setID] = useState<ID>(undefined)
  const [IDcluster, setIDcluster] = useState<ID>(undefined)
  const Type = useAppSelector(state => state.CloudSlice.Type)
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const nameregion = useAppSelector(state => state.RegionSlice.name)

  const [Records, setrecords] = useState<any[]>([])
  const [sus, setsus] = useState()

  useEffect(() => {
    if (currentUser?.ListPermiso?.includes('CTXR.Cluster.List')) {
      if (tenant === 0 && Id && Type !== 'CloudGlobal') {
        getclusters(Id, Type, nameregion).then(response => {
          setrecords(response.data)
        })
      }
      else if (tenant !== 0 && Id && Type !== 'CloudGlobal') {

        getclustersglobal(Id, tenant, Type, nameregion).then(response => {
          setrecords(response.data)
        })
      }
      else if (tenant === 0 && Id === -1) {
        getclusters(-1).then(response => {
          setrecords(response.data)
        })
      }
      else if (tenant !== 0 && Id === -1) {

        getclustersglobal(-1, tenant).then(response => {
          setrecords(response.data)
        })
      }
      else if (tenant === 0 && Id && Type === 'CloudGlobal') {
        getclusters(Id).then(response => {
          setrecords(response.data)
        })
      }
      else if (tenant !== 0 && Id && Type === 'CloudGlobal') {

        getclustersglobal(Id, tenant).then(response => {
          setrecords(response.data)
        })
      }
    }
  }, [Id, nameregion, props.tab])





  function reload() {
    if (currentUser?.ListPermiso?.includes('CTXR.Cluster.List')) {

      if (tenant === 0 && Id && Type !== 'CloudGlobal') {
        getclusters(Id, Type, nameregion).then(response => {
          setrecords(response.data)
        })
      }
      else if (tenant !== 0 && Id && Type !== 'CloudGlobal') {
        getclustersglobal(Id, tenant, Type, nameregion).then(response => {
          setrecords(response.data)
        })
      }
      else if (tenant === 0 && Id === -1) {
        getclusters(-1).then(response => {
          setrecords(response.data)
        })
      }
      else if (tenant !== 0 && Id === -1) {
        getclustersglobal(-1, tenant).then(response => {
          setrecords(response.data)
        })
      }
      else if (tenant === 0 && Id && Type === 'CloudGlobal') {
        getclusters(Id).then(response => {
          setrecords(response.data)
        })
      }
      else if (tenant !== 0 && Id && Type === 'CloudGlobal') {
        getclustersglobal(Id, tenant).then(response => {
          setrecords(response.data)
        })
      }
    }
  }


  const calculateOverallStatus = (ctxs: any) => {
    const problematicCTXs = ctxs.filter((ctx: any) => {
      // Verificar si alguno de los dos estados es incorrecto
      return ctx.status !== 'up' || ctx.statuspeer !== true;
    });

    if (problematicCTXs.length === 0) {
      return 'All good! The system is running smoothly and everything is in order.';
    } else {
      // Construir el mensaje con los CTX-R con problemas
      const issueMessage = problematicCTXs.map((ctx: any) => {
        return `${ctx.name}:\nInternet Status: ${ctx.status}\nHA Status: ${ctx.statuspeer}`;
      }).join('\n\n');
      return `Some issues detected. Please check individual CTX-R statuses below:
        \n\n${issueMessage}`;
    }
  };

  let totalDispositivosCtxr = 0;
  let trueCount = 0;
  let falseCount = 0;
  let nullCount = 0;

  for (const obj of Records) {
    totalDispositivosCtxr += obj.ctxr.length;
    for (const c of obj.ctxr) {
      if (c.statuspeer === true) {
        trueCount++;
      } else if (c.statuspeer === false) {
        falseCount++;
      } else {
        nullCount++;
      }
    }
  }

  return (
    <>
      <section className="card-header border-0 pt-6">
        <div className="card-title f-parrafo fw-bold text-marino fs-1"> High Availability Groups  </div>
        <div className="card-toolbar">
          <div className="d-flex justify-content-end">
            <button className="btn btn-light-marino me-3" onClick={reload}>Refresh</button>
            {currentUser?.ListPermiso?.includes('CTXR.Cluster.Add') && <button className="btn btn-success " onClick={() => setID(null)}>Add Cluster</button>}
          </div>
        </div>
      </section>
      <br />

      <section id="Groups" className="card card-custom shadow ">
        <div className="card-header">
          <div className="card-title f-parrafo fw-bold text-marino fs-3 "> Clusters </div>
          <div className="card-toolbar">
            <span className="me-2 f-parrafo text-marino ">Total Devices:</span> <strong className="f-parrafo me-3 text-azul"> {totalDispositivosCtxr}</strong>
            <span className="me-2 f-parrafo text-marino">Online Devices:</span> <strong className="f-parrafo me-3 text-success"> {trueCount}</strong>
            <span className="me-2 f-parrafo text-marino">Offline Devices:</span> <strong className="f-parrafo me-3 text-pink"> {falseCount}</strong>
            <span className="me-2 f-parrafo text-marino">Unknown Status:</span> <strong className="f-parrafo me-3"> {nullCount}</strong>
          </div>
        </div>
        <div className="card-body">
          <div className="row g-5 g-xl-8">
            {Records.length === 0 ? (
              <div className="text-center w-100">
                <span className='text-pink fw-bold fs-p'>No Data Available</span>
              </div>
            ) : (
              Records.map((d, i) => (
                <div className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <GroupsWidget
                    title={d.name}
                    name={d.name}
                    description={d.description}
                    ctxs={d.ctxr}
                    id={d.id}
                    setrecosrds={setrecords}
                    overallStatus={calculateOverallStatus(d.ctxr)} // Pasa el estado general calculado
                    setID={setIDcluster}
                    suscription={d.suscription}
                    enable={d.enable}
                  />
                </div>
              ))
            )}
          </div>
        </div>
      </section>

      <br />
      <CreateCluster setID={setID} id={ID} setrecords={setrecords}></CreateCluster>
      {IDcluster !== undefined && IDcluster !== null && <EdistCluster setID={setIDcluster} id={IDcluster} setrecords={setrecords}></EdistCluster>}

    </>
  )
}